import HelpIcon from '@/components/HelpIcon.jsx';
import IconV2 from '@/components/v2/IconV2.jsx';
import { memo } from 'react';
const SliderTitle = memo(({ icon, iconClassname = '', className = '', title, description, helpIconContext, tag }) => {
  return (
    <div className={`slider-title ${className}`}>
      <div className="slider-title-text">
        {icon && (
          <div className="slider-title-icon">
            <IconV2 icon={icon} className={iconClassname} size={20} />
          </div>
        )}
        <div className="title-row">
          <h3>{title}</h3>
          {helpIconContext && <HelpIcon context={helpIconContext} />}
          {tag}
        </div>
        <span className="description">{description}</span>
      </div>
    </div>
  );
});

SliderTitle.displayName = 'SliderTitle';

export default SliderTitle;
